import {Button, Form, Input} from 'antd';
import {useState} from 'react';
import toast from 'react-hot-toast';
import {useNavigate} from 'react-router-dom';

import {RQForgotPasswordAPI, RQResetPasswordAPI} from '../../reactQuery/apis';

// eslint-disable-next-line react/prop-types 
const ResetPasswordComponent = ({email = '', onResetSuccess}) => {
  const [isResetStage, setIsResetStage] = useState(false);

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const navigate = useNavigate();

  const {mutate: forgotPassword} = RQForgotPasswordAPI();

  const {mutate: resetPassword} = RQResetPasswordAPI({
    onSuccess: response => {
      setLoading(false);
      if (response) {
        toast.success('Password reset successful');
        form.resetFields();
        if (onResetSuccess) {onResetSuccess();} // <-- switch back to login modal
      } else {
        toast.error(response?.message || 'Something went wrong');
      }
    },
    onError: error => {
      setLoading(false);
      toast.error(error?.message || 'Something went wrong');
    },
  });

  const onFinish = values => {
    setLoading(true);
    if (isResetStage) {
      resetPassword({formData: values});
    } else {
      forgotPassword(
        {email: values.email},
        {
          onSuccess: () => {
            toast.success('Reset code sent to email.');
            setIsResetStage(true);
            setLoading(false);
          },
          onError: err => {
            toast.error(err?.response?.data?.message || 'Something went wrong');
          },
        },
      );
    }
  };

  return (
    <div className={'max-w-md mt-10'}>
      <Form
        form={form}
        layout={'vertical'}
        onFinish={onFinish}
        initialValues={{email}}
      >
        <Form.Item
          label={'Email'}
          name={'email'}
          rules={[
            {required: true, message: 'Email is required'},
            {type: 'email', message: 'Invalid email format'},
            {
              validator: (_, value) =>
                value && value !== value.toLowerCase()
                  ? Promise.reject('Email must be in lowercase')
                  : Promise.resolve(),
            },
          ]}
        >
          <Input disabled={isResetStage} placeholder={'Enter your email'} />
        </Form.Item>

        {isResetStage && (
          <>
            <Form.Item
              label={'Reset Code'}
              name={'resetCode'}
              rules={[{required: true, message: 'Reset code is required'}]}
            >
              <Input placeholder={'Enter reset code'} />
            </Form.Item>

            <Form.Item
              label={'New Password'}
              name={'newPassword'}
              rules={[
                {required: true, message: 'Password is required'},
                {min: 6, message: 'Password must be at least 6 characters'},
              ]}
            >
              <Input.Password placeholder={'Enter new password'} />
            </Form.Item>

            <Form.Item
              label={'Confirm Password'}
              name={'confirmPassword'}
              dependencies={['newPassword']}
              rules={[
                {required: true, message: 'Confirm Password is required'},
                ({getFieldValue}) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject('Passwords do not match');
                  },
                }),
              ]}
            >
              <Input.Password placeholder={'Confirm new password'} />
            </Form.Item>
          </>
        )}

        <Form.Item>
          <Button
            type={'default'}
            htmlType={'submit'}
            loading={loading}
            className={'text-white bg-primary-700 hover:bg-primary-700'}
          >
            {isResetStage ? 'Reset Password' : 'Send Reset Code'}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPasswordComponent;
